import { Badge, IconButton, SvgIcon, Tooltip } from "@mui/material";
import { HelpCircle as HelpCircleIcon } from "react-feather";
import { useTranslation } from "src/design-system/core/TranslationContext";
import { SHARED_LAYOUT_NAMESPACE, TOP_BAR_TK } from "../config";

const Help = (): JSX.Element => {
    const { t } = useTranslation(`${SHARED_LAYOUT_NAMESPACE}:${TOP_BAR_TK}`);

    const handleClick = (): void => {
        window.open(t("url_help"), "_blank");
    };

    return (
        <Tooltip title={t("help")}>
            <Badge color="default">
                <IconButton color="primary" onClick={handleClick}>
                    <SvgIcon fontSize="small">
                        <HelpCircleIcon />
                    </SvgIcon>
                </IconButton>
            </Badge>
        </Tooltip>
    );
};

export { Help };
